"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = exports.PopperPortal = exports.Reference = exports.Popper = exports.Manager = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var React = _interopRequireWildcard(require("react"));

var PropTypes = _interopRequireWildcard(require("prop-types"));

var _reactPopper = require("react-popper");

var _is = require("@utiljs/is");

var _reactResizeDetector = _interopRequireDefault(require("react-resize-detector"));

var _ClickOutside = _interopRequireDefault(require("../ClickOutside"));

var _AdvancedPortal = _interopRequireDefault(require("../AdvancedPortal"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _getOwnPropertySymbols.default === "function") for (var i = 0, p = (0, _getOwnPropertySymbols.default)(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var Manager = _reactPopper.Manager;
exports.Manager = Manager;
var Popper = _reactPopper.Popper;
exports.Popper = Popper;

var Reference = function Reference(props) {
  var Component = props.children,
      otherProps = __rest(props, ["children"]);

  if ((0, _is.isFunction)(Component)) {
    return /*#__PURE__*/React.createElement(_reactPopper.Reference, (0, _assign.default)({}, otherProps), Component);
  } else if ( /*#__PURE__*/React.isValidElement(Component)) {
    return /*#__PURE__*/React.createElement(_reactPopper.Reference, (0, _assign.default)({}, otherProps), function (_ref) {
      var ref = _ref.ref;
      return /*#__PURE__*/React.cloneElement(Component, {
        ref: ref
      });
    });
  }

  return Component;
};
/**
 * create Popper in body by Portal
 * Tips: Portal Popper， position strategy should be fixed
 * TODO: add Arrow
 */


exports.Reference = Reference;

var PopperPortal = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(PopperPortal, _React$PureComponent);

  var _super = _createSuper(PopperPortal);

  function PopperPortal() {
    var _this;

    (0, _classCallCheck2.default)(this, PopperPortal);
    _this = _super.apply(this, arguments);

    _this.handleClickOutside = function (e) {
      var onClickOutside = _this.props.onClickOutside;

      if ((0, _is.isFunction)(onClickOutside)) {
        onClickOutside(e);
      }
    };

    _this.renderChildren = function (popperProps) {
      var children = _this.props.children;

      if ((0, _is.isFunction)(children)) {
        return children((0, _assign.default)({}, popperProps));
      } else {
        return children;
      }
    };

    return _this;
  }

  (0, _createClass2.default)(PopperPortal, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _a = this.props,
          container = _a.container,
          children = _a.children,
          visible = _a.visible,
          lazy = _a.lazy,
          innerProps = _a.innerProps,
          disablePortal = _a.disablePortal,
          zIndex = _a.zIndex,
          className = _a.className,
          PopperProps = __rest(_a, ["container", "children", "visible", "lazy", "innerProps", "disablePortal", "zIndex", "className"]);

      return /*#__PURE__*/React.createElement(_AdvancedPortal.default, {
        visible: visible,
        disabled: disablePortal,
        lazy: lazy,
        zIndex: zIndex,
        container: container
      }, /*#__PURE__*/React.createElement(_reactPopper.Popper, (0, _assign.default)({
        positionFixed: false
      }, PopperProps), function (popperProps) {
        var placement = popperProps.placement,
            ref = popperProps.ref,
            style = popperProps.style,
            scheduleUpdate = popperProps.scheduleUpdate;
        var styles = (0, _assign.default)((0, _assign.default)({}, style), {
          zIndex: 1050
        });
        return /*#__PURE__*/React.createElement("div", {
          ref: ref,
          style: styles,
          className: "roo-popup ".concat(placement, " ").concat(className),
          "data-placement": placement
        }, /*#__PURE__*/React.createElement(_reactResizeDetector.default, {
          handleHeight: true,
          onResize: scheduleUpdate
        }, /*#__PURE__*/React.createElement(_ClickOutside.default, (0, _assign.default)({
          onClickOutside: _this2.handleClickOutside
        }, innerProps), _this2.renderChildren(popperProps))));
      }));
    }
  }]);
  return PopperPortal;
}(React.PureComponent);

exports.PopperPortal = PopperPortal;
PopperPortal.defaultProps = {
  lazy: false,
  visible: false,
  zIndex: 1000,
  className: '',
  disablePortal: false,
  onClickOutside: function onClickOutside() {}
};
PopperPortal.propTypes = {
  lazy: PropTypes.bool,
  visible: PropTypes.bool,
  className: PropTypes.string,
  disablePortal: PropTypes.bool,
  zIndex: PropTypes.number,
  onClickOutside: PropTypes.func
};
var _default = {
  PopperPortal: PopperPortal,
  Popper: Popper,
  Reference: Reference,
  Manager: Manager
};
exports.default = _default;